module.exports = __webpack_public_path__ + "img/ceo1.797f28ee.jpg";